import { Component, ChangeDetectionStrategy, ViewChild, ElementRef, ChangeDetectorRef, OnInit } from '@angular/core';
import { LabelsService, NotificationService } from '../../../../core/services';
import { ToolsService } from '../../../../core/services/ToolsService';
import { UsersService } from '../../../users/core/services/UsersService';
import { Observable, Subject } from 'rxjs';
import { debounceTime, finalize, map, tap } from 'rxjs/operators';
import { IUser } from '../../../users/core/interfaces/IUser';

@Component({
    selector: 'app-who-packed-label-print-modal',
    templateUrl: './who-packed-label-print-modal.component.html',
    styleUrls: ['./who-packed-label-print-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class WhoPackedLabelPrintModalComponent implements OnInit {

  @ViewChild('openPdfButtonElRef') openPdfButtonElRef: ElementRef<HTMLButtonElement>;

  public isVisible = false;
  public isConfirmLoading = false;
  public isLoading = false;
  public labelKey: string = null;
  public users$: Observable<IUser[]>;
  public areUsersLoading = false;
  public selectedUserId: number;
  public packerName: string;
  public quantity = 1;
  public readonly usersSearch$ = new Subject<string>();
  public readonly title = 'Logistikteam Namens-Etiketten drucken';

  private _users: IUser[] = [];
  private _isFirstLoad = true;

  constructor(
    private _cdr: ChangeDetectorRef,
    private readonly _notificationService: NotificationService,
    private readonly _toolsService: ToolsService,
    private readonly _usersService: UsersService,
    private readonly _labelsService: LabelsService,
  ) {}

  public ngOnInit(): void {
    this.fetchUsers();
    this.usersSearch$.pipe(debounceTime(500)).subscribe(this.fetchUsers.bind(this));
  }

  public onSearch(val: string): void {
    !this._isFirstLoad ? this.usersSearch$.next(val) : this._isFirstLoad = false;
  }

  public showModal(): void {
    this.isVisible = true;
    this.isLoading = false;
    this.isConfirmLoading = false;
    this._isFirstLoad = true;
    this.quantity = 1;
    this.packerName = null;
    this.selectedUserId = null;

    this._cdr.markForCheck();
  }

  public handleCancel(): void {
    this.isConfirmLoading = false;
    this.isVisible = false;
    this._cdr.markForCheck();
  }

  public handleOk(): void {
    const packerName = this.selectedUserId ?
      this._users.find(user => user.id === this.selectedUserId).firstName :
      this.packerName;

    if (!packerName) {
      this._notificationService.pushWarning('Warnung', 'Sie müssen sich für einen Packer entscheiden.');

      return;
    }

    this.isConfirmLoading = true;

    this._labelsService.generateWhoPackedLabel(packerName, this.quantity || 1).pipe(
      finalize(() => {
        this.isConfirmLoading = false;
        this._cdr.detectChanges();
        this._cdr.markForCheck();
      })
    ).subscribe(res => {
      this.labelKey = res.labelKey;
      setTimeout(() => this.openPdfButtonElRef.nativeElement.click());
    }, error => this._notificationService.pushError('Fehler', 'Fehler beim Erzeugen des Etiketts.'));
  }

  private fetchUsers(search = ''): void {
    this.areUsersLoading = true;
    this.users$ = this._usersService.getQueryableAll(
      1,
      10,
      null,
      null,
      [],
      [{ key: 'firstName', value: [search] }],
      []
    ).pipe(
      map(res => res.results),
      tap(users => {
        this.areUsersLoading = false;
        this._users = users;
      })
    );

    this._cdr.detectChanges();
  }
}
